const columnLabelsDefaults = {
    'id': {
        'ru': '#',
        'en': '#',
        'lv': '#'
    },
    'address': {
        'ru': 'Адрес',
        'en': 'Address',
        'lv': 'Adrese'
    },
    'code': {
        'ru': 'Код',
        'en': 'Code',
        'lv': 'Kods'
    },
    'select': {
        'ru': 'Выбрать',
        'en': 'Select',
        'lv': 'Izvēlēties'
    },
    'selected': {
        'ru': 'Выбрано',
        'en': 'Selected',
        'lv': 'Izvēlēts'
    }
}

const dataLabelsDefaults = {
    'code': {
        'ru': 'Код',
        'en': 'Code',
        'lv': 'Kods'
    },
    'address': {
        'ru': 'Адрес',
        'en': 'Address',
        'lv': 'Adrese'
    },
    'zipCode': {
        'ru': 'Индекс',
        'en': 'Zip code',
        'lv': 'Indekss'
    },
    'type': {
        'ru': 'Тип',
        'en': 'Type',
        'lv': 'Tips'
    },
    'structure': {
        'ru': 'Структура',
        'en': 'Structure',
        'lv': 'Struktūra'
    },
    'history': {
        'ru': 'История',
        'en': 'History',
        'lv': 'Vēsture'
    },
    'city': {
        'ru': 'Город',
        'en': 'City',
        'lv': 'Pilsēta'
    },
    'county': {
        'ru': 'Область',
        'en': 'County',
        'lv': 'Novads'
    },
    'parish': {
        'ru': 'Округ',
        'en': 'Parish',
        'lv': 'Pagasts'
    },
    'village': {
        'ru': 'Деревня',
        'en': 'Village',
        'lv': 'Ciems'
    },
    'street': {
        'ru': 'Улица',
        'en': 'Street',
        'lv': 'Iela'
    },
    'home': {
        'ru': 'Дом',
        'en': 'Home',
        'lv': 'Māja'
    },
    'apartment': {
        'ru': 'Квартира',
        'en': 'Apartment',
        'lv': 'Dzīvoklis'
    },
    'lksLat': {
        'ru': 'Lks koord lat',
        'en': 'Lks koord lat',
        'lv': 'Lks koord lat'
    },
    'lksLong': {
        'ru': 'Lks koord long',
        'en': 'Lks koord long',
        'lv': 'Lks koord long'
    },
}

const filterLabelsDefaults = {
    'expand': {
        'ru': 'Показать дополнительные фильтры',
        'en': 'Show additional filters',
        'lv': 'Parādīt papildu opcijas'
    },
    'collapse': {
        'ru': 'Спрятать дополнительные фильтры',
        'en': 'Hide additional filters',
        'lv': 'Paslēpt papildu opcijas'
    }
}

const inputSettingsDefaults = {
    requestTimeout: 300,
    field: {
        label: {
            'ru': 'Адрес для поиска',
            'en': 'Address to search',
            'lv': 'Meklējamā adrese'
        },
        placeholder: {
            'ru': 'Введите адрес для поиска',
            'en': 'Enter address to search',
            'lv': 'Ievadiet meklējamo adresi'
        }
    }
}

export {
    columnLabelsDefaults,
    dataLabelsDefaults,
    inputSettingsDefaults,
    filterLabelsDefaults
}